import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { ERR_MSG_404_TEMPLETE_ID } from '../../../constants/msgText'
import ProjectResponsiblerSettingWidget from '../../../widgets/projectProposal/ProjectResponsibler/ProjectResponsiblerSettingWidget'
import { getSettingFormProjectResponsiblerAndGrantee } from '../../../redux/actions/subProjectFormSetting'
import ProjectGranteeSettingWidget from '../../../widgets/projectProposal/ProjectGrantee/ProjectGranteeSettingWidget'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'

export default function ProjectResponsiblerSetting(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    if (formId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_TEMPLETE_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSettingFormProjectResponsiblerAndGrantee(formId)
      // const _schema = mockSchema
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProjectSetting>
          <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

          {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

          {schema.buttonRoute && <BtnEditAll routing={schema.buttonRoute} hiddenBtnEdit />}

          {schema?.forms?.projectGrantor && (
            <ProjectGranteeSettingWidget schema={schema.forms.projectGrantor} />
          )}

          {schema?.forms?.projectResponsibler && (
            <ProjectResponsiblerSettingWidget schema={schema.forms.projectResponsibler} />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
